import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Pagination from "../../common/Pagination";
import OrderItem from "../items/OrderItem";
import { ORDER_PER_PAGE } from "../../../constants/Constants";
import { connect } from 'react-redux';

const styles = () => ({
  root: {
    width: "80%",
    margin: 'auto',
    boxSizing: "border-box",
  },

  orderContainer: {
    boxShadow: '0px 0px 3px #00000026',
  },

  paginationContainer: {
    margin: "40px 0px 80px 0px",
  },
});

class ResultSection extends React.Component {
  render() {
    const { classes, pageInfo, orders, isLoading } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.orderContainer}>
          {(orders.valueSeq().map(order => (
            <OrderItem
              key={order.id}
              item={order}
              displayNotification={this.props.displayNotification}
              goTo={this.props.goTo}
              ownerType={this.props.ownerType}
              selectedYear={this.props.selectedYear}
              selectedMonth={this.props.selectedMonth}
            />
          )
          ))}
        </div>
        {orders.size > 0 && pageInfo && (
          <div className={classes.paginationContainer}>
            <Pagination
              currentPage={pageInfo.current_page}
              lastPage={pageInfo.last_page}
              total={pageInfo.total}
              perPage={ORDER_PER_PAGE}
              showLastPage={false}
              disabled={isLoading}
              onChange={(data) => {
                this.props.getOrderList({
                  page: data.page,
                  per_page: data.per_page,
                });
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

ResultSection.propTypes = {
  classes: PropTypes.object.isRequired,
  getOrderList: PropTypes.func.isRequired,
  orders: PropTypes.object.isRequired,
  displayNotification: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageInfo: PropTypes.object.isRequired,
  ownerType: PropTypes.string.isRequired,
  selectedYear: PropTypes.string,
  selectedMonth: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ResultSection));



// WEBPACK FOOTER //
// ./src/components/OrderList/sections/ResultSection.jsx